import { render } from "./PromptIcon.vue?vue&type=template&id=0ee2dd59&scoped=true"
import script from "./PromptIcon.vue?vue&type=script&lang=js"
export * from "./PromptIcon.vue?vue&type=script&lang=js"

import "./PromptIcon.vue?vue&type=style&index=0&id=0ee2dd59&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee2dd59"]])

export default __exports__